export enum PFApiMessages {
  PF_UPDATED = 'Processing Facility Updated Successfully',
  PF_DELETED = 'Processing Facility Deleted',
}
